import { render, staticRenderFns } from "./refund-project-detail.vue?vue&type=template&id=60828317&scoped=true&"
import script from "./refund-project-detail.vue?vue&type=script&lang=js&"
export * from "./refund-project-detail.vue?vue&type=script&lang=js&"
import style0 from "./refund-project-detail.vue?vue&type=style&index=0&id=60828317&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60828317",
  null
  
)

export default component.exports